/**
 * The age range for allowance-by-age tables: one row per age, inclusive.
 * Shared by UserContext (saving the tables) and allowanceChecks
 * (validating them). Not in legacyComponents.
 */
export const MAX_BENEFIT_AGE_LIST = {
  MINIMUM_AGE: 21,
  MAXIMUM_AGE: 64,
};
